var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 131,
    viewBox: "0 0 187 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 20,
    r: 111,
    fill: "#FFDC5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse29);
export default __webpack_public_path__ + "static/media/Ellipse 29.ee02ad3628f5f261a344de681f480773.svg";
export { ForwardRef as ReactComponent };